import Container from "@/components/layout/Container";

export default function SolutionsHero() {
  return (
    <div className="border-b border-border-soft bg-bg-light">
      <Container>
        <div className="flex flex-col gap-2 py-4 md:py-5">

          <div className="flex items-center gap-2 text-[12px] text-text-muted">
            <a href="/" className="hover:text-text-primary transition">
              Home
            </a>
            <span>/</span>
            <span className="text-text-primary font-medium">Solutions</span>
          </div>

          <h1 className="max-w-[28ch] text-[20px] md:text-[26px] font-semibold leading-snug text-text-primary">
            Management built to maximise revenue and simplify ownership
          </h1>

        </div>
      </Container>
    </div>
  );
}